
import { Controller } from "stimulus";

export default class extends Controller {

  // this controller is meant to be used when you can change the project with the select
  // it is used when you select a user and want to add an investor contribution and need to choose which project

  initialize() {
    this.projectTotalAmount = 0.0;
    this.unitPurchasePrice = 0.0;
    this.totalNumberOfUnits = 0.0;
    this.purchasedUnits = 0.0;
    this.ownershipPercentage = 0.0;
    this.amountPaid = 0.0;

    this.currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',

      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    this.numberFormatter = new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 3
    });

  }

  connect() {
    console.log("Hello, Contribution Creation!", this.element)
  }

  static targets = [ "project", "amount", "price", "totalUnits", "ownership", "investorUnits", "projectName", "projectInfo", "paid"];

  load() {

    let url = this.projectTarget.getAttribute("data-url");
    let index = this.projectTarget.selectedIndex;
    let projectId = this.projectTarget.options[index].value;

    if (projectId == '') {
      this.projectInfoTarget.classList.add('is-hidden');
      return;
    }

    let path = `${url}?id=${projectId}`;
    console.log('path ', path);

    fetch(path, {
      credentials: 'include'
    }).then(response => response.json())
      .then(data => this.setProjectData(data));
  }

  setProjectData(data) {
    console.log('setProjectData: ', data);
    this.projectTotalAmount = data.total_amount;
    this.unitPurchasePrice = data.unit_purchase_price;
    this.totalNumberOfUnits = data.total_number_of_units;
    console.log(this.totalNumberOfUnits);

    let formattedAmount = this.currencyFormatter.format(this.projectTotalAmount);
    this.amountTarget.textContent = formattedAmount;

    let formattedPrice = this.currencyFormatter.format(this.unitPurchasePrice);
    this.priceTarget.textContent = formattedPrice;

    let totalUnits = this.numberFormatter.format(this.totalNumberOfUnits);
    this.totalUnitsTarget.textContent = totalUnits;

    this.projectNameTarget.textContent = data.name;
    this.projectInfoTarget.classList.remove('is-hidden');
  }

  calculate() {
    this.purchasedUnits = this.investorUnitsTarget.value;
    console.log('val ', this.purchasedUnits);
    let ratio = (this.purchasedUnits / this.totalNumberOfUnits);
    this.ownershipPercentage = ratio * 100.0;
    this.ownershipTarget.textContent = this.numberFormatter.format(this.ownershipPercentage) + '%';
    this.amountPaid = ratio * this.projectTotalAmount;
    this.paidTarget.textContent = this.currencyFormatter.format(this.amountPaid);
  }
}